function base64ToArrayBuffer(data: string) {
  const bString = window.atob(data);
  const bLength = bString.length;
  const bytes = new Uint8Array(bLength);
  for (let i = 0; i < bLength; i++) {
    bytes[i] = bString.charCodeAt(i);
  }
  return bytes;
}

export default function saveFile(base64Content: string, fileName: string, mimeType: string) {
  const bufferArray = base64ToArrayBuffer(base64Content);
  const blobStore = new Blob([ bufferArray ], { type: mimeType });

  const data = window.URL.createObjectURL(blobStore);
  const link = document.createElement('a');
  document.body.appendChild(link);
  link.href = data;
  link.download = `${fileName}`;
  link.click();
  window.URL.revokeObjectURL(data);
  link.remove();
}